import { createContext } from 'react';

export interface formIsDirtyContextProps {
  formIsDirty: boolean;
  setFormIsDirty: (value: boolean) => void;
}

export const formIsDirtyContext = createContext<formIsDirtyContextProps>({
  formIsDirty: false,
  setFormIsDirty: () => {},
});
